/// <reference types="gtag.js" />

window.dataLayer = window.dataLayer ?? []; // eslint-disable-line @typescript-eslint/no-unnecessary-condition -- For initialization, we assume this to be undefined

const gtag: Gtag.Gtag = function () {
  window.dataLayer.push(arguments); // eslint-disable-line prefer-rest-params -- Follow standard Google example
};

window.gtag = gtag;

// Set default consent to 'denied'; see https://developers.google.com/tag-platform/security/guides/consent
gtag('consent', 'default', {
  ad_storage: 'denied',
  ad_user_data: 'denied',
  ad_personalization: 'denied',
});
gtag('set', 'ads_data_redaction', true);
gtag('js', new Date());

let initialized = false;

Drupal.behaviors.google_analytics = {
  attach: (_context, settings) => {
    const config = settings.sslleiden;
    if (config.ga_id && !initialized) {
      initialized = true; // prevent from running twice

      const script = document.createElement('script');
      script.defer = true;
      script.src = `https://www.googletagmanager.com/gtag/js?id=${config.ga_id}`;
      script.type = 'text/javascript';
      document.head.appendChild(script);

      /* For a full list of configuration options, see https://developers.google.com/analytics/devguides/collection/ga4/reference/config */
      gtag('config', config.ga_id, {
        allow_ad_personalization_signals: false,
        allow_google_signals: false,
        cookie_flags: 'SameSite=Lax;Secure',
      });
    }
  },
};

export {}; // required to make TypeScript happy

declare global {
  interface Window {
    dataLayer: Array<unknown>;
  }
}
